var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconSearch = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M14.6993 15.7598C13.5458 16.6823 12.0833 17.2335 10.4918 17.2335C6.76875 17.2335 3.74925 14.2148 3.74925 10.4918C3.74925 6.76875 6.76875 3.75 10.4918 3.75C14.2148 3.75 17.2328 6.76875 17.2328 10.4918C17.2328 12.0833 16.6815 13.5458 15.7598 14.6993L20.0093 18.9488C20.3018 19.2413 20.3018 19.7168 20.0093 20.0093C19.7168 20.3018 19.2413 20.3018 18.9488 20.0093L14.6993 15.7598ZM15.7328 10.4918C15.7328 7.59675 13.3868 5.25 10.4918 5.25C7.59675 5.25 5.24925 7.59675 5.24925 10.4918C5.24925 13.3868 7.59675 15.7335 10.4918 15.7335C13.3868 15.7335 15.7328 13.3868 15.7328 10.4918Z", fill: "black" }))),
        alt: 'Icon Search',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconSearch;
//# sourceMappingURL=index.js.map